import axiosInstance from "../../../api/axiosInstance";
import { endpoints } from "../../../services/endpoints";
import { getCategoriesRequest, getCategoriesRequestError, getCategoriesRequestSuccess } from "../../slices/Category/GetCategoriesSlice";

export const GetCategoriesApi = (data) => async (dispatch) => {
    const queryParams = new URLSearchParams(data).toString();
    const url = `${endpoints.getCategories}?${queryParams}`;
    try {
        dispatch(getCategoriesRequest());
        axiosInstance({
            method: "GET",
            url: url,
            headers: { "Content-Type": "application/json" },
        })
            .then((resp) => {
                return dispatch(getCategoriesRequestSuccess(resp?.data));
            })
            .catch((error) => {
                const _error = {
                    data: error?.response?.data?.message || error?.message,
                    status: error?.response?.status || error?.status,
                };
                return dispatch(getCategoriesRequestError(_error));
            });
    } catch (error) { }
};
